// covered-by: frontends/carrie/src/ask-v2/routes/__tests__/pageRoutes.test.ts
// eslint-disable-next-line import/named
import { createRoute } from "@tanstack/react-router";

import { askV2AuthLayoutRoute } from "./authLayout";

import { AskV2ProjectPage } from "../pages/AskV2ProjectPage";

export const askV2ProjectReviewRoute = createRoute({
  getParentRoute: () => askV2AuthLayoutRoute,
  path: "ask-puntt/projects/$projectId/reviews/$reviewId",
  component: AskV2ProjectReviewRoutePage,
});

export const askV2ProjectReviewCommentRoute = createRoute({
  getParentRoute: () => askV2AuthLayoutRoute,
  path: "ask-puntt/projects/$projectId/reviews/$reviewId/comments/$commentId",
  component: AskV2ProjectReviewCommentRoutePage,
});

function AskV2ProjectReviewRoutePage() {
  const { projectId, reviewId } = askV2ProjectReviewRoute.useParams();
  return (
    <AskV2ProjectPage
      key={projectId}
      projectId={projectId}
      reviewId={reviewId}
    />
  );
}

function AskV2ProjectReviewCommentRoutePage() {
  const { projectId, reviewId, commentId } =
    askV2ProjectReviewCommentRoute.useParams();
  return (
    <AskV2ProjectPage
      key={projectId}
      projectId={projectId}
      reviewId={reviewId}
      commentId={commentId}
    />
  );
}
